import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import Spinner from './Spinner';

interface Props {
	title?: string;
	description?: string | JSX.Element;
	callToActionText?: string;
	callToActionHandler?: () => void;
	emptyContent?: JSX.Element;
	isLoading: boolean;
	isEmpty: boolean;
	render: () => JSX.Element | null;
}

const EmptyState = (props: Props) => {
	const classes = useStyles();
	const {
		title,
		description,
		callToActionHandler,
		callToActionText,
		isLoading,
		isEmpty,
		render,
		emptyContent,
	} = props;

	if (!isLoading && !isEmpty) return render();

	if (isLoading) {
		return (
			<Box className={classes.wrapper}>
				<Spinner in size={30} />
			</Box>
		);
	}
	if (Boolean(emptyContent)) {
		return <>{emptyContent}</>;
	} else {
		return (
			<Box className={classes.wrapper}>
				<Typography variant="h6" className={classes.title}>
					{title}
				</Typography>
				<Typography variant="body2" className={classes.description}>
					{description}
				</Typography>
				{callToActionText && callToActionHandler && (
					<Button
						onClick={callToActionHandler}
						className={classes.button}
						variant="contained"
						color="primary"
					>
						{callToActionText}
					</Button>
				)}
			</Box>
		);
	}
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		wrapper: {
			position: 'relative',
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			padding: theme.spacing(4),
		},
		title: {
			color: theme.palette.text.primary,
			maxWidth: '600px',
			textAlign: 'center',
		},
		description: {
			color: theme.palette.text.secondary,
			maxWidth: '600px',
			textAlign: 'center',
		},
		button: {
			marginTop: theme.spacing(4),
		},
	}),
);

export default EmptyState;
